import { render, staticRenderFns } from "./user-interface-7-large-number-display.vue?vue&type=template&id=24dc421c&scoped=true&"
import script from "./user-interface-7-large-number-display.vue?vue&type=script&lang=ts&"
export * from "./user-interface-7-large-number-display.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dc421c",
  null
  
)

export default component.exports